import React from "react";
import brandMark from "../assets/brand-mark.svg";

/**
 * Smooth brand lockup: SVG mark + HTML type (avoids jagged JPEG cutouts).
 */
const BrandLogo = ({ className = "" }) => (
  <div className={`brand-logo ${className}`.trim()} role="img" aria-label="Ahavibes">
    <img className="brand-logo__mark" src={brandMark} alt="" />
    <div className="brand-logo__text">
      <span className="brand-logo__name">AHAVIBES</span>
      <span className="brand-logo__tagline">Stop reacting. Start thinking clearly.</span>
    </div>
  </div>
);

export default BrandLogo;
